var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2204 31.7459C41.1242 31.4561 40.739 31.0697 40.3538 30.9731C36.406 30.0072 32.4582 29.1378 28.5104 28.2684C28.2215 28.1718 27.7401 28.4616 27.5475 28.7514C26.9698 29.6208 26.4883 30.5868 26.1032 31.5527C25.8143 32.3255 25.4291 32.1323 24.5625 32.1323C20.5184 32.1323 10.2156 21.7965 10.3119 17.836C10.3119 16.9667 10.2156 16.6769 10.8896 16.2905C11.8525 15.9041 12.8154 15.3245 13.6819 14.8415C13.9708 14.6483 14.1634 14.1654 14.1634 13.8756C13.2968 9.91512 12.4302 5.95466 11.4673 1.99421C11.371 1.70442 11.0822 1.22144 10.697 1.12484C6.26774 0.35207 0.779297 3.05677 0.779297 12.33C0.779297 23.5352 16.378 41.5987 29.9547 41.5987C39.2947 41.6953 41.9908 36.1893 41.2204 31.7459Z",
    fill: "#E1EAF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.877 11.1679L36.1112 5.9292",
    stroke: "#FF6900",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9883 8.54839V2",
    stroke: "#FF6900",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4941 18.3711H40.037",
    stroke: "#FF6900",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallIcon);
export default __webpack_public_path__ + "static/media/phoneCallIcon.5765a379f08e8f94c61e3a6e944ed2cb.svg";
export { ForwardRef as ReactComponent };